import React,{useEffect, useState} from "react";
import { Grid, Typography } from "@material-ui/core";
import { Container, MTable, Panel,PaginationTable, Pagination } from "../../../../Components";
import { useStyles } from "./Customer.styles";
import { useIntl } from 'react-intl';
import { useNavigate} from 'react-router-dom';
import CustomerServicesApi from '../../../../Redux/Actions/CustomerAction';
import { useDispatch, useSelector } from "react-redux";
import { useApiValidationSnackbar } from "../../../../Components/Snackbar/SnackbarAlert";
import { UserStatus } from "../../../../Context/UserContext/UserContext";
import { useSnackbar } from 'notistack';
  interface ICompanyUser {
    organisationId: any;
    id: number;
    name: string;
    email: string;
    status?: UserStatus;
    mobile:any;
    ftpUserName:any;
    ftpPassword:any;
    isDeleted:boolean;
  }
export const Customer = ()=>{
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const navigate = useNavigate();
    const tableRef = React.createRef();
    const dispatch:any = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [reloadPage,setReload] = useState(false)
    const [data,setData] = useState<any>({name:"test1"});
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const {allCustomers,apiToken} = useSelector((state:any)=>({
      allCustomers:state?.CustomerReducer?.allCustomers,
      apiToken:state?.UserReducer?.apiToken,
    }));
    const {ErrorMessage}= useApiValidationSnackbar();
    useEffect(()=>{
      try {
        dispatch(CustomerServicesApi?.customers(apiToken));
      } catch (error) {
        let internalError:any = 'internalError'
        ErrorMessage(allCustomers,internalError)
      }
    },[])
    const activation = (user: ICompanyUser) => (
      {
        tooltip: user?.isDeleted==true?formatMessage({ id: 'component.mtable.activateTooltip' }):formatMessage({ id: "component.mtable.inactivateTooltip" }),
        icon: user?.isDeleted==true?'check':'block',
        onClick: async () => {
          setReload(true)
          dispatch(CustomerServicesApi?.changeCustomerStatus(user?.id,apiToken,enqueueSnackbar))
          setTimeout(() => {
            dispatch(CustomerServicesApi?.customers(apiToken));
            setReload(false)
          },1500);
        },
      })
    const edit =(user:ICompanyUser)=>({
      tooltip:formatMessage({ id: 'component.mtable.editTooltip' }),
      icon:'edit',
      onClick:()=>{
        dispatch(CustomerServicesApi.getCustomerById(user?.id,apiToken))
        setTimeout(() => {
          navigate(`/administration/update-form/${user?.id}`,{state:{user}})
        },1500)
      }
    })
    const {pagination,toolbar,body,header} = Pagination(); 
    return(
        <Container fullWidth>
            <Panel titleKey="customer.header" titleValues={"button"} buttonTitle={"addCustomer"} pathLink={'/administration/customer'}>
            <Grid>
                 <MTable 
                 tableRef={tableRef} 
                 columns={[
                  { title:formatMessage({id:"customer.table.name",defaultMessage:"Name"}), field: "companyName"},
                  { title: formatMessage({id:"form.contact.person",defaultMessage:"Contact person"}), field: "contactPerson" },
                  {title:formatMessage({id:"customer.table.organisationid",defaultMessage:"Organisation number"}),field:"organisationId"},
                 
                ]} 
                isLoading={reloadPage}
                data={allCustomers?.length == undefined?[]:allCustomers} 
                onPageChange={(page)=>setPage(page)}
                onRowsPerPageChange={(pageSize:any)=> setRowsPerPage(parseInt(pageSize, 10))}
                actions={[edit,activation]}
                localization={{pagination,toolbar,body,header}}
                 components={{
                  Pagination: (props: any) => (
                    <Grid component="td" container justifyContent="space-between">
                      <Grid item>
                        <Typography className={classes.total}>
                          {formatMessage({ id: 'component.mtable.total' })}
                          &nbsp;{allCustomers?.length}
                        </Typography>
                      </Grid>
                      <Grid item justifyContent="flex-end" alignItems="flex-end" >
                        <PaginationTable
                         props={ props}
                         page = {page}
                         rowsPerPage={rowsPerPage}
                          count={allCustomers}
                        />
                      </Grid>
                    </Grid>
                  ),
                }}
                 />
            </Grid>
            </Panel>
        </Container>
    )
}